import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'minmax(20px, auto) auto',
    margin: '0 2rem',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: '0 10px',
      gap: '2px'
    }
  },
  iconRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'transparent'
  },

  start: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    fontSize: theme.size.sm,
    justifyContent: 'center'
  },
  dividerLabel: {
    minHeight: '17px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.sm,
    textAlign: 'center',
    color: '#8F8F8F',
    cursor: 'default',

    '& strong': {}
  },
  mobileDividerLabel: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.sm,
    textAlign: 'center',
    color: '#8F8F8F',
    cursor: 'default',

    '& strong': {}
  },
  verifiedIcon: {
    marginLeft: '0.5rem',
    '& svg': { flexShrink: 0 }
  }
}))

export default useStyles
